import { render } from "./ERemittanceReport.vue?vue&type=template&id=6adecf41&ts=true"
import script from "./ERemittanceReport.vue?vue&type=script&lang=ts"
export * from "./ERemittanceReport.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__